import { render } from "./ControlView.vue?vue&type=template&id=80518120&scoped=true"
import script from "./ControlView.vue?vue&type=script&lang=js"
export * from "./ControlView.vue?vue&type=script&lang=js"

import "./ControlView.vue?vue&type=style&index=0&id=80518120&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80518120"]])

export default __exports__